import { render } from "./App.vue?vue&type=template&id=fb5f0868"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fb5f0868&lang=less"

import exportComponent from "/home/runner/work/suplasercut-admin/suplasercut-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__